import * as R from "ramda"
import React from "react"
import { withRouter } from "react-router"
import { Button } from "semantic-ui-react"
import styled from "styled-components"
import Login from "../../containers/Login"
import Signup from "../../containers/Signup"
import { isLogin, endRegisterRace } from "../../utils/index"

const StyledDiv = styled.div.attrs({
  className: "ui"
})`
  && {
    display: none;
    @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
      display: block;
      background-color: white;
      z-index: 999;
      min-height: 65px;
      position: fixed;
      bottom: 0px;
      left: 50%;
      right: 50%;
      margin-left: -50vw;
      margin-right: -50vw;
    }
  }
`
class RegisterRace extends React.Component {
  state = {
    showLogin: false,
    showSignup: false
  }
  render() {
    const { racesDetail, slug, special, close_registration } = this.props
    return (
      <React.Fragment>
        <StyledDiv>
          <div
            style={{
              float: "left",
              marginLeft: "35px",
              position: "absolute",
              top: "30%"
            }}
          >
            <h3>
              {" "}
              {special ? (
                <span>
                  <s>{R.path(["price"], racesDetail[0])}</s>
                  <span style={{ color: "red", fontWeight: "bold" }}>
                    {` ${R.path(["special_price"], racesDetail[0])} ฿`}
                  </span>
                </span>
              ) : (
                <span>{`${R.path(["price"], racesDetail[0])} ฿`}</span>
              )}{" "}
            </h3>
          </div>
          {!endRegisterRace(this.props.race) ? (
            <Button
              onClick={() => {
                this.props.isRegistered
                  ? this.props.history.push(`/me`)
                  : isLogin() && special
                  ? this.props.history.push(
                      `/races/${slug}/register/?special=true`
                    )
                  : isLogin() && !special
                  ? this.props.history.push(`/races/${slug}/register`)
                  : this.setState({ showLogin: true })
              }}
              style={{
                position: "absolute",
                top: "15%",
                right: "5px"
              }}
              positive
            >
              สมัครเลย!
            </Button>
          ) : (
            <Button
              style={{
                position: "absolute",
                top: "15%",
                right: "5px"
              }}
              negative
            >
              ปิดรับสมัคร
            </Button>
          )}
        </StyledDiv>
        <Login
          open={this.state.showLogin}
          onClose={() => this.setState({ showLogin: false })}
          toggleSignup={() => {
            this.setState({ showLogin: false })
            this.setState({ showSignup: true })
          }}
        />
        <Signup
          open={this.state.showSignup}
          onClose={() => this.setState({ showSignup: false })}
        />
      </React.Fragment>
    )
  }
}

export default withRouter(RegisterRace)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/RegisterRace/mobile.js